/**
 * Datapoint configurations.
 */
export default {
    ReminderDefaultOption: {
        datapoint: {
            name: 'ReminderDefaultOption',
            customData: function (reminderDuration) { return [reminderDuration]; },
        },
    },
    EventDurationDefaultOption: {
        datapoint: {
            name: 'EventDurationDefaultOption',
            customData: function (eventDuration) { return [eventDuration]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map